import { render, staticRenderFns } from "./KKPBankPopup.vue?vue&type=template&id=4a152052&scoped=true"
import script from "./KKPBankPopup.vue?vue&type=script&lang=js"
export * from "./KKPBankPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a152052",
  null
  
)

export default component.exports